import { MAX_IMAGE_UPLOADS } from '../constants/imageUploadConfig';

const feedbackOnStageUtils = {
    colorAddedToLibrary: (colorValue, theme, intl) => {
        return {
            label: intl.formatMessage(
                {
                    id: 'feedback.colorAdded.label',
                },
                { colorValue },
            ),
            type: 'success',
            show: true,
            icon: theme.site.feedback.icon.add,
        };
    },
    colorRemovedFromLibrary: (colorValue, theme, intl) => {
        return {
            label: intl.formatMessage(
                {
                    id: 'feedback.colorRemoved.label',
                },
                { colorValue },
            ),
            type: 'success',
            show: true,
            icon: theme.site.feedback.icon.remove,
        };
    },
    colorCopied: (colorValue, theme, intl) => {
        return {
            label: intl.formatMessage(
                {
                    id: 'feedback.colorCopied.label',
                },
                { colorValue },
            ),
            type: 'success',
            show: true,
            icon: theme.site.feedback.icon.copied,
        };
    },
    colorNotCopied: (colorValue, theme, intl) => {
        return {
            label: intl.formatMessage(
                {
                    id: 'feedback.colorNotCopied.label',
                },
                { colorValue },
            ),
            type: 'danger',
            show: true,
            icon: theme.site.feedback.icon.notCopied,
            timeout: 4000,
        };
    },
    setMainColor: (colorValue, theme, intl) => {
        return {
            label: intl.formatMessage(
                {
                    id: 'feedback.setMainColor.label',
                },
                { colorValue },
            ),
            type: 'success',
            show: true,
            icon: theme.site.feedback.icon.mainColor,
        };
    },
    setImageUploadLimitError: (theme, intl) => {
        return {
            label: intl.formatMessage(
                { id: 'dominantImageColors.upload.limit' },
                { maxImages: MAX_IMAGE_UPLOADS },
            ),
            type: 'danger',
            show: true,
            icon: theme.site.feedback.icon.error,
            timeout: 4000,
        };
    },
    setFileImageError: (theme, intl) => {
        return {
            label: intl.formatMessage({
                id: 'feedback.setFileImage.label',
            }),
            type: 'danger',
            show: true,
            icon: theme.site.feedback.icon.error,
        };
    },
};

export default feedbackOnStageUtils;
